export default function Skeleton({ type }) {
  return (
    <main>
      {type === "sub" && (
        <>
          <div className="mx-14 px-8 py-6 bg-dark rounded-lg mb-4">
            <div>
              <div className="blog-post o-media">
                <div>
                  <span className="skeleton-box rounded-lg" style={{ width: "401px", height: "213px" }}></span>
                </div>
                <div className="o-media__body">
                  <div className="o-vertical-spacing">
                    <h3 className="blog-post__headline">
                      <span className="skeleton-box bg-dark" style={{ width: "55%" }}></span>
                    </h3>
                    <p className="mt-4">
                      <span className="skeleton-box" style={{ width: "80%s" }}></span>
                      <span className="skeleton-box" style={{ width: "90%" }}></span>
                      <span className="skeleton-box" style={{ width: "83%" }}></span>
                      <span className="skeleton-box" style={{ width: "80%" }}></span>
                    </p>
                    <div className="blog-post__meta mt-8">
                      <span className="skeleton-box rounded-3xl p-5" style={{ width: "128px", height: "24px" }}></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mx-14 px-8 py-6 bg-dark rounded-lg mb-4">
            <ul className="o-vertical-spacing o-vertical-spacing--l">
              <li className="blog-post o-media">
                <div>
                  <span className="skeleton-box rounded-lg" style={{ width: "401px", height: "213px" }}></span>
                </div>
                <div className="o-media__body">
                  <div className="o-vertical-spacing">
                    <h3 className="blog-post__headline">
                      <span className="skeleton-box bg-dark" style={{ width: "55%" }}></span>
                    </h3>
                    <p className="mt-4">
                      <span className="skeleton-box" style={{ width: "80%" }}></span>
                      <span className="skeleton-box" style={{ width: "90%" }}></span>
                      <span className="skeleton-box" style={{ width: "83%" }}></span>
                      <span className="skeleton-box" style={{ width: "80%" }}></span>
                    </p>
                    <div className="blog-post__meta mt-8">
                      <span className="skeleton-box rounded-3xl p-5" style={{ width: "128px", height: "24px" }}></span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div className="mx-14 px-8 py-6 bg-dark rounded-lg ">
            <ul className="o-vertical-spacing o-vertical-spacing--l">
              <li className="blog-post o-media">
                <div className="o-media__figure">
                  <span className="skeleton-box rounded-lg" style={{ width: "401px", height: "213px" }}></span>
                </div>
                <div className="o-media__body">
                  <div className="o-vertical-spacing">
                    <h3 className="blog-post__headline">
                      <span className="skeleton-box bg-dark" style={{ width: "55%" }}></span>
                    </h3>
                    <p className="mt-4">
                      <span className="skeleton-box" style={{ width: "80%" }}></span>
                      <span className="skeleton-box" style={{ width: "90%" }}></span>
                      <span className="skeleton-box" style={{ width: "83%" }}></span>
                      <span className="skeleton-box" style={{ width: "80%" }}></span>
                    </p>
                    <div className="blog-post__meta mt-8">
                      <span className="skeleton-box rounded-3xl p-5" style={{ width: "128px", height: "24px" }}></span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </>
      )}
      {type === "match" && (
        <>
          <SkeletonMatch />
          <SkeletonMatch />
          <SkeletonMatch />
        </>
      )}
      {type === "rank" && (
        <>
          <SkeletonRank />
        </>
      )}
    </main>
  )
}
function SkeletonMatch() {
  const loop = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  loop.length = 10
  return (
    <>
      <div className="rounded-lg mb-8 max-w-screen-xl">
        <span className="skeleton-box bg-dark py-5  rounded-lg mb-2" style={{ width: "100%" }}></span>
        <div className="grid grid-cols-2 gap-4">
          {loop.map((item, index) => {
            return (
              <div className="col-span-1 bg-dark p-4 rounded" key={index}>
                <div className="grid gap-2 grid-cols-7">
                  {/* <div className="col-span-1" dangerouslySetInnerHTML={{ __html: ConvertTime(time) }}></div> */}
                  <div className="col-span-1 text-center">
                    <div className="font-bold skeleton-box" style={{ width: "100%" }}></div>
                    <div className="text-sm text-primary-300 skeleton-box" style={{ width: "100%" }}></div>
                  </div>
                  <div className="col-span-6">
                    <div className="grid grid-cols-2 gap-4 relative">
                      <div className="col-span-1 flex items-center justify-end mr-12">
                        <span className="mr-2 font-bold skeleton-box" style={{ width: "60%" }}></span>
                        <div className="rounded-full skeleton-box" style={{ width: "48px", height: "48px" }}></div>
                      </div>
                      <div className="text-center absolute left-1/2 top-0 transform  -translate-x-1/2  rounded w-[96px] mt-4">
                        <div
                          className="text-dark-100 font-bold text-lg skeleton-box rounded-lg"
                          style={{ width: "60%" }}
                        ></div>
                      </div>
                      <div className="text-center col-span-1 flex items-center justify-start ml-12">
                        <div className="rounded-full skeleton-box" style={{ width: "48px", height: "48px" }}></div>
                        <span className="ml-2 font-bold skeleton-box" style={{ width: "60%" }}></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}
function SkeletonRank() {
  const loop = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
  loop.length = 10
  return (
    <>
      <div className="rounded-lg mb-8 w-[778px] m-auto">
        <span className="skeleton-box bg-dark py-5  rounded-lg mb-1" style={{ width: "100%" }}></span>
        <div className="">
          {loop.map((item, index) => {
            return (
              <div key={index}>
                <span className="skeleton-box bg-dark py-5  rounded-lg mb-1" style={{ width: "100%" }}></span>
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}
